import React from 'react';
import { NewMenuItem } from 'ui/src/data/MenuItem';
import addUrlHostName from 'ui/src/utils/addUrlHostname';

interface Props {
  children: React.ReactNode;
  className?: string;
  item: NewMenuItem;
  onClick?: () => void;
}

export default function MobileMenuItemWrapper({ children, className, onClick, item }: Props) {
  const { url } = item;

  if (item.sections.length > 0) {
    return (
      <button className={className} onClick={onClick} type="button">
        {children}
      </button>
    );
  }

  return url ? (
    <a href={`${addUrlHostName(url)}?nav=new`} className={className}>
      {children}
    </a>
  ) : (
    <button className={className} onClick={onClick} type="button">
      {children}
    </button>
  );
}
